import BlackButton from './ui/BlackButtonUi'

export default BlackButton
